import cs from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useMemo } from 'react';
import { Button } from '@/DesignSystem/Component';
import type { IButtonColorType } from '@/DesignSystem/Model/DataModel';
import { FILE_BROWSER_URL, LINKS } from '@/Module/Core/Constant';
import { useAppSelector } from '@/Module/Store/Hook';
import SubscriptionInoDescription from '@/Module/Subscription/Component/SubscriptionInoPage/SubscriptionInoDescription';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
const BOX_CLASS: Record<string, string> = {
  blue: 'sm:before:hidden sm:border-[4px] sm:border-b-[10px] border-t-[15px] sm:border-blueFour bg-white !shadow-[0px_0px_4px_0px_rgba(38,57,68,0.08)] !shadow-[0px_0px_7px_1px_rgba(25,119,242,1.00)] sm:shadow-[0px_4px_8px_-2px_rgba(0,0,0,0.10)]'
};
const BUTTON_COLOR: Record<string, IButtonColorType> = {
  green: 'green',
  blue: 'blueN',
  orange: 'blackN',
  pink: 'pink'
};
const SubscriptionInoPlan: FC<ISubscriptionPlan> = ({
  subscriptionName,
  color,
  subscriptionDescription,
  id,
  price,
  duration,
  metaData
}) => {
  const {
    originalPrice = 0,
    price: mainPrice = 0
  } = price ?? {};
  const isLoggedIn = useAppSelector(state => state.auth.isLoggedIn);
  const router = useRouter();
  const [title, subtitle] = useMemo(() => subscriptionName.split('_'), [subscriptionName]);
  return <div className={cs(BOX_CLASS[color], `relative max-w-full  flex-1 shadow-[0px_4px_8px_-2px_rgba(0,0,0,0.10)] bg-white pb-0 rou border-b px-4 pt-6 sm:pt-10 sm:pb-2  flex flex-col !border-t-0 text-blackSeven rounded-xl sm:rounded-3xl`)} data-sentry-component="SubscriptionInoPlan" data-sentry-source-file="SubscriptionInoPlan.tsx">
      {color === 'blue' && <>
          <div className="z-1 absolute right-[-4px] top-[-45px] hidden w-[calc(100%+8px)] rounded-t-3xl bg-blueFour pb-8 pt-2 text-center font-bold text-white before:absolute before:bottom-[-4px] before:right-[4px] before:z-[10] before:h-6 before:w-[calc(100%-8px)] before:rounded-t-3xl before:bg-white sm:block">
            فرصت محدود
          </div>
          <Image src={`${FILE_BROWSER_URL}/img/focus-plan.png`} width={56} height={49} alt="focus" className="z-1 absolute right-[-12px] top-[-10px] sm:hidden" />
        </>}
      <span className={cs(`block text-blackFive mb-1 text-center text-xl font-extrabold `)}>{title}</span>
      {subtitle && <span className={cs(`hidden sm:block mb-2 text-center text-blackThree font-semibold text-[12px] `)}>{subtitle}</span>}

      {!!originalPrice && <div className={cs('relative mx-auto flex flex-row w-fit text-center mt-4 ')}>
          <span className={cs(`text-sm font-semibold text-white border-[1px] border-orangeFive rounded-lg px-3 ml-2 pt-[2px] bg-orangeFour`)}>
            80 % تخفیف
          </span>
          <div className="relative before:absolute before:top-[14px] before:h-[1px] before:w-full before:-rotate-6 before:bg-orangeFive">
            <span className={cs(`text-md md:text-xl font-semibold text-blackFour`)}>{originalPrice.toLocaleString()}</span>
            <span className={cs(` font-semibold text-blackFour mr-1`)}>تومان</span>
          </div>
        </div>}

      <div className="mb-4 flex items-center  justify-center gap-2 text-center first:border sm:mb-8">
        <span className="text-lg">{duration === null ? 'سالیانه/' : 'ماهانه/'}</span>
        <span className={cs(`text-4xl font-bold text-blueFour mt-2 `)}>{mainPrice.toLocaleString()}</span>
        <span className={cs(`text-lg md:text-2xl font-semibold text-blackFour`)}>تومان</span>
      </div>

      <div className="relative mx-auto h-12 w-full max-w-[240px] self-end overflow-hidden rounded-3xl border-[1px] border-transparent transition-all duration-1000 hover:border-[1px] hover:border-blueFive sm:mb-2">
        <span className="absolute mt-[12px] w-full text-center  text-[16px] font-bold !text-orangeFive ">
          همین حالا فعال کن!
        </span>
        <Button type="button" name="Hover" className="mbn-button h-full w-full cursor-pointer  text-[16px] font-bold text-white " href={isLoggedIn ? LINKS.SUBSCRIPTION.ITEM.replace('[id]', String(id)) : `${LINKS.AUTH.LOGIN}?redirectUrl=${encodeURI(router.asPath)}`} as={Link} radius="circle" color={BUTTON_COLOR[color] ?? 'primary'} variant="contained" data-sentry-element="Button" data-sentry-source-file="SubscriptionInoPlan.tsx">
          همین حالا فعال کن!
        </Button>
      </div>

      <div className="my-2 items-center justify-center text-center sm:mb-4">
        <span className={cs(`text-sm text-blueFour font-semibold ml-1`)}>
          {metaData ? metaData?.toLocaleString() : '۹۱۳٬۵۷۰'}
        </span>
        <span className={cs(`text-sm text-blackThree`)}>دانش‌آموز اشتراک را تهیه کرده‌اند.</span>
      </div>
      <ul className={cs(' transition-all duration-200 sm:mb-2 sm:flex-1 h-auto flex-1')}>
        <SubscriptionInoDescription subscriptionDescription={subscriptionDescription} data-sentry-element="SubscriptionInoDescription" data-sentry-source-file="SubscriptionInoPlan.tsx" />
      </ul>
    </div>;
};
export default SubscriptionInoPlan;